require('./accountCertificateView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

//@commons
import OKLayout from 'components/commons/OKLayout/OKLayout';
const { FormattedText, formatText, getFinalTitle } = require('core/i18n').i18n;
const AccountCertificates = require('components/accounts/accountCertificates/accountCertificates');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const ContactInfoBox = require('components/myProfile/contactInfoBox/contactInfoBox');
const accountDetailsCertificatesActions = require('actions/accountDetailsCertificates');
const AccountMoreOptionsButton = require('components/accounts/accountMoreOptionsButton/accountMoreOptionsButton');

// @utilities
const AccessHelper = require('utilities/accessHelper');
const { getLastNChars } = require('utilities/stringHelper');

// @constants
const { accountConstants } = require('utilities/accessHelperConditions/accounts');
import { NEGATIVE } from 'constants/layout';
import extendAccountFunctionality from '../../components/accounts/extendAccountFunctionality/extendAccountFunctionality';
const { VIEWER } = require('constants/contactCenter/pdfViewer');

class AccountCertificateView extends React.Component {
    constructor(props) {
        super(props);
        this.callbackDownloadFile = this.callbackDownloadFile.bind(this);
        this.handleOpenPDFViewer = this.handleOpenPDFViewer.bind(this);
    }

    componentDidMount() {
        const { history, immAccounts, match: { params: { accountId } } } = this.props;
        AccessHelper.allowAccess(accountConstants.ACCOUNTS_DETAILS, { immAccounts, accountId }, history);
    }

    componentWillUnmount() {
        this.props.clearAccountDetailDocumentState();
    }

    callbackDownloadFile(file) {
        const { match: { params: { accountId } }, immAccounts } = this.props;
        const immAccount = immAccounts.getIn(['byId', accountId])
        this.props.getAccountDetailsDocuments(file.get('fileName'), immAccount.get('ibanComplex'));
    }

    handleOpenPDFViewer(file) {
        const { match: { params: { accountId } }, immAccounts } = this.props;
        const immAccount = immAccounts.getIn(['byId', accountId])
        this.props.getAccountDetailsDocuments(file.get('fileName'), immAccount.get('ibanComplex'), VIEWER);
    }

    render() {
        const { match: { params: { accountId } }, immAccounts, accountDetailsCertificates, handleOptionsClick } = this.props;
        const immAccount = immAccounts.get('byId').get(accountId);
        const subtitleLeft = immAccount.get('catalogData').get('subtype');
        const subtitleRight = getLastNChars(immAccount.get('iban'));
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-accounts'),
                url: '/myprofile/accounts'
            },
            {
                text: immAccount.get('alias'),
                url: `/myprofile/accounts/${accountId}/movements`
            },
            {
                text: formatText('breadcrumb-certificates'),
                url: ''
            }
        ];
        return (
            <OKLayout
                breadcrumb={mappingBreadcrumb}
                buttons={<AccountMoreOptionsButton accountId={accountId} onOptionClick={handleOptionsClick} />}
                contentPosition={NEGATIVE}
                title={getFinalTitle(formatText('certificateSection-title'))}
                loading={!immAccount}
                section="accounts"
                subtitleLeft={subtitleLeft}
                subtitleRight={subtitleRight}
            >
                <div className="row">
                    <div className="col-xs-12 col-md-8">
                        <div className="row">
                            <div className="col-md-12">
                                <OKSectionBox
                                    title={formatText('certificateSection-title')}
                                >
                                    <AccountCertificates
                                        documents={accountDetailsCertificates.get('documents')}
                                        callbackDownloadFile={__CONTACT_CENTER__ ? this.handleOpenPDFViewer : this.callbackDownloadFile}
                                        className={'account-certificate-view__certificates'}
                                    />
                                </OKSectionBox>
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-4">
                        <div className="row">
                            <div className="col-md-12">
                                <ContactInfoBox
                                    boxTitle={formatText('certificateSection-information')}
                                    boxBody={<FormattedText value="certificateSection-informationText" />}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </OKLayout>
        );
    }
}

AccountCertificateView.propTypes = {
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    accountDetailsCertificates: PropTypes.object,
    getAccountDetailsDocuments: PropTypes.func,
    clearAccountDetailDocumentState: PropTypes.func
}

module.exports.constructor = AccountCertificateView;
module.exports.AccountCertificateView = connect(
    state => ({
        immAccounts: state.accounts,
        accountDetailsCertificates: state.accountDetailsCertificates
    }), {
    getAccountDetailsDocuments: accountDetailsCertificatesActions.getAccountDetailsDocuments,
    clearAccountDetailDocumentState: accountDetailsCertificatesActions.clearAccountDetailDocumentState
}
)(withRouter(extendAccountFunctionality(AccountCertificateView)));
